// import { getChatSession } from './getChatSession'
// import { saveChatSession } from './saveChatSession'

import { getChatSession } from './getChatSession'
import { saveChatSession } from './saveChatSession'

/**
 * @param {string} payload
 */
export function handleChatCustomerId(payload) {
  const session = getChatSession()
  session.users = session.users.map((u) => {
    if (u.type === 'customer') {
      return {
        ...u,
        id: payload,
      }
    }
    return u
  })

  saveChatSession(session)
}
